import React from "react";
import PropTypes from "prop-types";
import Input from "../../../../components/Input";
import CheckCircle from "@material-ui/icons/CheckCircle";
import { useIntl } from "react-intl";
import { getFullCloudFrontURL } from "../../../../utils/Constants";

function QuizAnswerView({ question, questionIndex }) {
  const { messages } = useIntl();

  const { quizzes } = messages;
  return (
    <div className=" py-4">
      <div className=" show active">
        {question?.answer_choices_attributes.map(
          (answer, answerIndex) => {
            return (
              !answer._destroy && (
                <div
                  className="mx-5 d-flex align-items-center"
                  key={JSON.stringify(answerIndex)}
                >
                  <span className="mb-2 mr-1 ">
                    {answerIndex + 1} -
                  </span>
                  <div className="flex-fill ml-1 d-flex align-items-center">
                    {answer.image_url && (
                      <div item className="pb-0">
                        <img
                          src={getFullCloudFrontURL(answer.image_url)}
                          alt="medblend"
                          width="100px"
                          className={`img-thumbnail m-3 img`}
                        />
                      </div>
                    )}
                    {answer.answer && (
                      <div className="flex-fill">
                        <Input
                          name={`questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].answer`}
                          label={quizzes?.answer}
                          isRequired={false}
                        />
                      </div>
                    )}
                    {question.answer_choices_attributes[answerIndex]
                      .correct && (
                      <span
                        className={`icon alert alert-success`}
                        role="alert"
                      >
                        <CheckCircle
                          color="success"
                          className="me-2"
                        />
                      </span>
                    )}
                  </div>
                </div>
              )
            );
          }
        )}
      </div>
    </div>
  );
}

QuizAnswerView.propTypes = {
  question: PropTypes.object.isRequired,
  questionIndex: PropTypes.number.isRequired
};

export default QuizAnswerView;
